module.exports = __webpack_public_path__ + "img/tn-timeline-main-7.cedd4a4a.jpg";